import { themeGet } from '@styled-system/theme-get'
import { Image, Link } from 'pcln-design-system'
import React from 'react'
import styled from 'styled-components'

const SMALL_IMAGE_HEIGHT = '250px'
const LARGE_IMAGE_HEIGHT = '500px'

const ResponsiveImage = styled(Image)`
  aspect-ratio: ${(props) => (props.imageAspectRatio ? props.imageAspectRatio : '16/9')};
  object-fit: ${(props) => (props.objectFit ? props.objectFit : 'contain')};
  display: flex;
  flex-grow: ${(props) => (props.flexGrow ? props.flexGrow : '0')};
  max-height: ${SMALL_IMAGE_HEIGHT};
  min-height: unset;

  ${themeGet('mediaQueries.md')} {
    min-height: ${(props) => (props.minImageHeight ? props.minImageHeight : SMALL_IMAGE_HEIGHT)};
    max-height: ${LARGE_IMAGE_HEIGHT};
  }
`

const LinkWrapper = ({ callToAction, children }) => {
  const { ariaLabel, openInNewTab, longUrl, url } = callToAction || {}

  return callToAction ? (
    <Link
      aria-label={ariaLabel}
      data-testid='image-link-id'
      href={longUrl || url}
      rel={openInNewTab ? 'noopener' : undefined}
      target={openInNewTab ? '_blank' : undefined}
    >
      {children}
    </Link>
  ) : (
    children
  )
}

function MerchImage({ callToAction, imageAlt, imageUrl, ...imageProps }) {
  return (
    <LinkWrapper callToAction={callToAction}>
      <ResponsiveImage {...imageProps} alt={imageAlt} width='100%' loading='lazy' src={imageUrl} />
    </LinkWrapper>
  )
}

export default MerchImage
